import { createI18n } from 'vue-i18n'
import zhCN from './zh-cn'
import en from './en-us'
import { resolveLocale } from './locale'

const i18n = createI18n({
  // 如果localStorage有沒有值，如果沒有就取瀏覽器
  locale: resolveLocale(localStorage.getItem('locale'), navigator.language),
  fallbackLocale: 'en-US',
  messages: {
    'zh-CN': zhCN,
    'en-US': en
  }
})
export default i18n
